









import { Component, Mixins } from "vue-property-decorator";
import { ModelEditableMixin } from "../../../../system/mixins";
import { EditingDocument } from "../..";
import { MenuPane } from "../../../../panes";

@Component({
  components: {
    MenuPane,
  }
})
export default class CalculationMenu extends Mixins(ModelEditableMixin) {
  editingSource: EditingDocument;

  data(): any {
    return {
      isProcessing: false,
    };
  }
  isProcessing: boolean;

  get isEnable(): boolean {
    return this.$configuration.behavior.document.editor.calculationMenu.isEnable;
  }

  calculate(): void {
    this.isProcessing = true;
    try {
      // TODO:計算を走らせる処理の実装
      // 常時走っているので特に何かをする必要はない？
      this.editingSource.externalScriptRunner.calculate();
    } catch (e) {
      this.isProcessing = false;
      this.$error("計算エラー", "計算処理中にエラーが発生しました。", e);
      return;
    }
    this.editingSource.executeStackedScriptsAsyncWithResult()
    .then((isSuccess) => {
      this.isProcessing = false;
      if (!isSuccess) {
        this.$error("外部スクリプト", "外部スクリプトの実行中にエラーが発生しています。");
      }
    }).catch(e => {
      this.isProcessing = false;
      this.$error("計算エラー", "計算処理中にエラーが発生しました。", e);
    });
  }
}
